import { enhance, handle } from "@grrr/hansel";
import { onDomReady } from "@grrr/ready";
import { followMouse } from "./modules/follow-mouse";
import { ticker } from "./modules/ticker";
import { addClass } from "./modules/add-class";
import { collapse } from "./modules/collapse";
import { flexiHeader } from "./modules/flexi-header";
import { svgInline } from "./modules/svg-inline";
import { masonry } from "./modules/masonry";
import { hideOnScroll } from "./modules/hide-on-scroll";
import { backToTop } from "./modules/back-to-top";
import { clickableSuperscripts } from "./modules/clickable-superscripts";
import { activateTab } from "./modules/activate-tab";
import { readMore } from "./modules/read-more";
import { mobileMenu } from "./modules/mobile-menu";
import { followNonAnchorLink } from "./modules/follow-non-anchor-link";
import { editorCorrections } from "./modules/editor-corrections";
import { addArrows } from "./modules/add-arrows";
import { socialMenu } from "./modules/social-menu";
import { initSubMenuToggle, toggleSubMenu } from "./modules/toggle-sub-menu";
import { editionMenu } from "./modules/edition-menu";
import { clickToScroll } from "./modules/click-to-scroll";
import { lightbox } from "./modules/lightbox";

Number.prototype.map = function (in_min, in_max, out_min, out_max) {
    return (
        ((this - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
    );
};

onDomReady(() => {
    enhance(document.documentElement, {
        socialMenu,
        followMouse,
        ticker,
        flexiHeader,
        svgInline,
        masonry,
        hideOnScroll,
        lightbox,
        clickableSuperscripts,
        readMore,
        mobileMenu,
        editorCorrections,
        addArrows,
        editionMenu,
        initSubMenuToggle,
    });
    handle(document.documentElement, {
        addClass,
        collapse,
        backToTop,
        activateTab,
        followNonAnchorLink,
        toggleSubMenu,
        clickToScroll,
    });
});
